import ImageUrlProfile from "components/app/image-url/ImageUrlProfile";
import { Button } from "components/ui/button";
import { Card } from "components/ui/card";
import { useRef, useState, useEffect } from "react";
import { profileVerified } from "assets";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FriendStatus } from "utils";
import DailogSuggestionFriend from "components/app/dialog/dialog-suggestion-friend/DialogSuggestionFriend";
import { newFeedStore } from "store/newFeedStore";

export default function NewFeedSuggestionFriend({ post }: { post: any }) {
  const { t } = useTranslation();
  const {
    onSuggestionFollowingUser,
    onSuggestionUnFollowingUser,
    onSuggestionUninterestUser,
  } = newFeedStore();
  const [hovered, setHovered] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const [suggestionUsers, setSuggestionUsers] = useState<any[]>([]);
  const lookingFors = ["Friend", "Love", "Business", "Job", "Staff"];

  const [dialogSuggestionFriend, setDialogSuggestionFriend] = useState({
    isOpen: false,
    looking: "",
  });

  const _onClickSearchMore = (looking: string) => {
    setDialogSuggestionFriend({ isOpen: true, looking: looking });
  };

  useEffect(() => {
    const loadInitialPosts = async () => {
      setSuggestionUsers([
        ...(post.suggestion_users ?? []),
        { id: "temp", name: "What are you looking?" },
      ]);
    };

    loadInitialPosts();
  }, [post.suggestion_users]);

  return (
    <div
      className="relative mb-4"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div className="flex flex-row justify-between items-center mb-2">
        <p>{t("Suggestion Friends")}</p>

        <Button
          variant="secondary"
          onClick={() => _onClickSearchMore("")}
          size={"sm"}
        >
          {t("Search Mores")}
        </Button>
      </div>
      <div
        ref={containerRef}
        className={`flex overflow-x-auto space-x-2 no-scrollbar ${
          hovered ? "scrollbar-visible" : "scrollbar-custom"
        }`}
      >
        {suggestionUsers.map((user) =>
          user.id === "temp" ? (
            <Card key={user.id} className="w-48 pt-1 rounded-lg flex-grow">
              <div className="w-48 rounded-md space-y-2 p-2">
                <p className="p-1 flex w-full justify-center items-center">
                  {t("What are you looking?")}
                </p>
                {lookingFors.map((element) => (
                  <Button
                    key={element}
                    variant="outline"
                    className="p-1 flex w-full justify-center items-center"
                    onClick={() => _onClickSearchMore(element)}
                  >
                    {element}
                  </Button>
                ))}
              </div>
            </Card>
          ) : (
            <div
              key={user.id}
              className="relative w-48  flex-shrink-0 cursor-pointer rounded-xl overflow-hidden"
            >
              <Card key={user.id} className="rounded-md space-y-2 ">
                <Link
                  to={`/profile?id=${user?.id}&feed`}
                  className="cursor-pointer relative overflow-hidden"
                >
                  {user.status === "Unpublished" && (
                    <div className="absolute z-10 top-8 -right-16 rotate-45 w-full bg-red-700 text-white text-center font-sans py-1 opacity-80">
                      <span>{user.status}</span>
                    </div>
                  )}
                  <ImageUrlProfile
                    className="w-full object-cover h-[200px] rounded-t-md"
                    user={user}
                  />
                  {/* Name */}
                  <div className="p-2">
                    <div className="flex">
                      <h1 className="font-semibold text-lg line-clamp-1">
                        {user?.name}
                      </h1>
                      {user?.is_verified === "Yes" ? (
                        <>
                          <div className="flex items-center justify-center pt-0.5 ml-1">
                            <img
                              src={profileVerified}
                              style={{ width: 24, height: 24 }}
                              alt=""
                            />
                          </div>
                        </>
                      ) : (
                        <></>
                      )}
                    </div>
                    <p
                      className={`line-clamp-1 ${
                        user?.bio === "" ? "invisible" : ""
                      }`}
                    >
                      {user?.bio !== "" ? user?.bio : "NoBio"}
                    </p>
                  </div>
                </Link>

                {/* Follower Post Like */}
                <div className="grid grid-cols-3 text-center">
                  <div className="">
                    <h1 className="font-semibold">{user?.no_of_follower}</h1>
                    <p className="text-xs">Followers</p>
                  </div>
                  <div className="">
                    <h1 className="font-semibold">{user?.no_of_post}</h1>
                    <p className="text-xs">Posts</p>
                  </div>
                  <div className="">
                    <h1 className="font-semibold">{user?.no_of_like}</h1>
                    <p className="text-xs">Likes</p>
                  </div>
                </div>

                <div className="flex flex-row p-2 space-x-2">
                  {FriendStatus.getType(user.friend_status) ===
                    FriendStatus.follow ||
                  FriendStatus.getType(user.friend_status) ===
                    FriendStatus.follower ||
                  FriendStatus.getType(user.friend_status) ===
                    FriendStatus.none ? (
                    <Button
                      variant="secondary"
                      onClick={() =>
                        onSuggestionUninterestUser(post, `${user.id}`)
                      }
                      size={"sm"}
                      className="flex-1"
                    >
                      {t("Remove")}
                    </Button>
                  ) : (
                    <></>
                  )}

                  {FriendStatus.getType(user.friend_status) ===
                  FriendStatus.following ? (
                    <Button
                      variant="destructive"
                      onClick={() =>
                        onSuggestionUnFollowingUser(post, `${user.id}`)
                      }
                      size={"sm"}
                      className="flex flex-1"
                    >
                      {t("Following")}
                    </Button>
                  ) : (
                    <Button
                      variant="destructive"
                      onClick={() =>
                        onSuggestionFollowingUser(post, `${user.id}`)
                      }
                      size={"sm"}
                      className="flex flex-1"
                    >
                      {t("Follow")}
                    </Button>
                  )}
                </div>
              </Card>
            </div>
          )
        )}
      </div>

      <DailogSuggestionFriend
        isDialogOpen={dialogSuggestionFriend.isOpen}
        looking={dialogSuggestionFriend.looking}
        setIsDialogOpen={(isOpen) =>
          setDialogSuggestionFriend({ ...dialogSuggestionFriend, isOpen })
        }
      />
    </div>
  );
}

